import { ThunkResult } from "common/reducers";
import { RootDispatchType, RootGetState } from "common/store";
import { IdsManagementActions } from "common/reducers/idsManagement.actions";
import { getCronofyUrl, list, syncCalendars, syncEvents, update } from "common/api/calendar.service";
import { List } from "immutable";
import { CalendarActions } from "common/reducers/calendar.actions";
import { handleErrors } from "common/reducers/Utils";
import { CalendarRecord, ICalendarData } from "common/records/Calendar";
import { addFlashAlert } from "common/components/FlashAlert";
import { dirtyCalendars } from "common/selectors/calendar.selectors";

export const CalendarAsyncActions = {
  listCalendars: (): ThunkResult<Promise<void>> => {
    return async (dispatch: RootDispatchType, getState: RootGetState) => {
      try {
        dispatch(IdsManagementActions.fetchModel("calendars"));

        const { calendars } = await list();

        dispatch(CalendarActions.receiveCalendars(calendars));
        dispatch(IdsManagementActions.receiveModel("calendars", List(calendars.map((a) => a.id))));
      } catch (errors) {
        handleErrors(errors);
        dispatch(IdsManagementActions.receiveModel("calendars", List()));
      }
    };
  },
  updateCalendars: (): ThunkResult<Promise<void>> => {
    return async (dispatch: RootDispatchType, getState: RootGetState) => {
      dispatch(IdsManagementActions.fetchModel("calendars"));

      const dirtyRecords = dirtyCalendars(getState());
      let savedCalendars = List<ICalendarData>();
      try {
        await Promise.all(
          dirtyRecords.map(async (record) => {
            const { calendar } = await update(record);
            savedCalendars = savedCalendars.push(calendar);
          }),
        );

        dispatch(CalendarActions.receiveCalendars(savedCalendars.toJS() as ICalendarData[]));
        addFlashAlert("success", "Calendars saved");
      } catch (errors) {
        handleErrors(errors);
      } finally {
        dispatch(IdsManagementActions.setModelLoaded("calendars"));
      }
    };
  },
  getCronofyUrl: (): ThunkResult<Promise<void>> => {
    return async (dispatch: RootDispatchType, getState: RootGetState) => {
      try {
        const { url } = await getCronofyUrl();

        dispatch(CalendarActions.receiveCronofyUrl(url));
      } catch (errors) {
        handleErrors(errors);
      }
    };
  },
  syncCalendars: (): ThunkResult<Promise<void>> => {
    return async (dispatch: RootDispatchType, getState: RootGetState) => {
      try {
        await syncCalendars();

        addFlashAlert("success", "Sync request submitted");
      } catch (errors) {
        handleErrors(errors);
      }
    };
  },
  syncEvents: (calendarRecord: CalendarRecord): ThunkResult<Promise<void>> => {
    return async (dispatch: RootDispatchType, getState: RootGetState) => {
      try {
        await syncEvents(calendarRecord);

        addFlashAlert("success", "Full event sync started");
      } catch (errors) {
        handleErrors(errors);
      }
    };
  },
};
